import { Component } from "@angular/core";

/**
 * Uday's gradient car plus the R-Hero wordmark. The icon gradient stays
 * #00ff8f → #00a1ff. The wordmark is currentColor, so it follows the theme
 * text token. The SVG has no background tile.
 */
@Component({
  selector: "app-rhero-logo",
  standalone: true,
  templateUrl: "./rhero-logo.component.html"
})
export class RheroLogoComponent {}
